import type { MeliIntegrationRecoveryAlertProps } from 'src/modules/settings/types/meli-integration-recovery.types';
import { getMeliIntegrationRecovery } from 'src/modules/settings/utils/meli-integration-recovery.util';
import { Alert } from 'src/modules/shared/components/atoms/alert';
import Button from 'src/modules/shared/components/atoms/buttons/button';

/** Shows the permitted recovery action for a recoverable MeLi failure. */
export function MeliIntegrationRecoveryAlert({
  connection,
  canRead,
  canUpdate,
  canSyncNow,
  isBusy,
  startingOAuth,
  syncing,
  onStartOAuth,
  onSync,
  t,
}: MeliIntegrationRecoveryAlertProps) {
  const recovery = getMeliIntegrationRecovery(connection);
  if (!canRead || !recovery) {
    return null;
  }
  const reauthorizing = recovery.action === 'reauthorize';
  return (
    <Alert
      variant="warning"
      size="md"
      role="status"
      ariaLive="polite"
      className="mb-4"
      message={t(recovery.messageKey)}
      action={
        (reauthorizing ? canUpdate : canSyncNow) ? (
          <Button
            variant="warning"
            appearance="outline"
            size="sm"
            disabled={isBusy || startingOAuth || syncing}
            loading={reauthorizing ? startingOAuth : syncing}
            onClick={reauthorizing ? onStartOAuth : onSync}
          >
            {t(recovery.actionLabelKey)}
          </Button>
        ) : undefined
      }
    />
  );
}
